import { Reducer } from 'redux';
import AppActionTypes from './types';
import { THEME, USERSROLE, MAP_DEFAULT_VAR } from 'types';
import { AppState } from './types';

export const initialState: AppState = {
  loading: false,
  theme: THEME.BASE,
  userRole: USERSROLE.OTHER,
  selectedBasemap: MAP_DEFAULT_VAR.BASEMAP,
  baseMapTheme: 'dark',
  loginType: null,
  isSignOutLoading: undefined,
  headerPanelExpand: undefined,
  appVisiblePanel: undefined,
  showInterstitialPage: true
};

const reducer: Reducer<AppState> = (state = initialState, action: any) => {
  switch (action.type) {
    case AppActionTypes.INIT_APP_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    case AppActionTypes.INIT_APP_SUCCESS: {
      const { mapSearchLocationHistory, showCLOListing } = state;
      return {
        ...state,
        loading: false,
        mapSearchLocationHistory,
        showCLOListing,
        error: undefined
      };
    }
    case AppActionTypes.INIT_APP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || undefined
      };
    case AppActionTypes.SET_APP_THEME:
      return {
        ...state,
        theme: action.payload
      };
    case AppActionTypes.SET_APP_LANGUAGE:
      return {
        ...state,
        language: action.payload
      };
    case AppActionTypes.SET_APP_USER_ROLE:
      return {
        ...state,
        userRole: action.payload
      };
    case AppActionTypes.SET_APP_AUTH_TYPE:
      return {
        ...state,
        loginType: action.payload
      };
    case AppActionTypes.SET_MAP_SEARCH_LOCATION_HISTORY:
      return {
        ...state,
        mapSearchLocationHistory: action.payload
      };

    case AppActionTypes.SET_APP_INITIAL_STATE: {
      const { mapSearchLocationHistory, showCLOListing } = state;
      return {
        ...state,
        mapSearchLocationHistory,
        showCLOListing
      };
    }
    case AppActionTypes.SET_HEADER_PANEL_EXPAND:
      return {
        ...state,
        headerPanelExpand: action.payload
      };
    case AppActionTypes.RESET_APP_AUTH_STATE_START: {
      const {
        mapSearchLocationHistory,
        selectedBasemap,
        baseMapTheme,
        showCLOListing
      } = state;
      return {
        ...state,
        loading: true,
        mapSearchLocationHistory,
        selectedBasemap,
        baseMapTheme,
        showCLOListing,
        isSignOutLoading: true
      };
    }
    case AppActionTypes.RESET_APP_AUTH_STATE_FINISH: {
      const {
        mapSearchLocationHistory,
        selectedBasemap,
        baseMapTheme,
        appVisiblePanel,
        showCLOListing
      } = state;
      return {
        ...initialState,
        mapSearchLocationHistory,
        selectedBasemap,
        baseMapTheme,
        appVisiblePanel,
        showCLOListing
      };
    }
    case AppActionTypes.SET_BASE_MAP:
      return {
        ...state,
        selectedBasemap: action.payload.baseMap,
        baseMapTheme: action.payload.theme
      };
    case AppActionTypes.SET_APP_VISIBLE_PANEL: {
      return {
        ...state,
        appVisiblePanel: action.payload.appVisiblePanel
      };
    }
    case AppActionTypes.SET_SHOW_CLO_LISTING: {
      return {
        ...state,
        showCLOListing: action.payload
      };
    }
    case AppActionTypes.SET_SHOW_INTERSTITIAL_PAGE: {
      return {
        ...state,
        showInterstitialPage: action.payload
      };
    }
    default:
      return state;
  }
};

export { reducer as AppReducer };
